import { Card, Checkbox, Radio, Typography } from 'antd';

import { cn } from '@/lib/cn';

export type AnswerBlockOption = {
  content: {
    title?: string;
    description: string;
  };
  skip?: number;
  value: string;
};

export type OptionsProps = {
  options: AnswerBlockOption[];
  selection: string[];
  type?: 'single' | 'multiple';
  handleSelectOption: (value: string, isSelected: boolean) => void;
};

const GROUP_CLASS_NAME = 'flex flex-col gap-2';

const Options = ({ options, selection, type = 'single', handleSelectOption }: OptionsProps) => {
  const isMultiple = type === 'multiple';

  const items = options.map(({ content, value }, index) => {
    const isSelected = selection.includes(value);

    return (
      <Card
        key={index}
        size='small'
        type='inner'
        id={`answer-option-${index}`}
        className={cn('hover:border-primary cursor-pointer transition-colors', {
          'border-(--uizz-antd-color-primary) bg-(--uizz-antd-color-primary-bg)': isSelected
        })}
        onClick={() => handleSelectOption(value, isSelected)}
      >
        {isMultiple ? (
          <Checkbox value={value} checked={isSelected} className='sr-only' id={`answer-option-${index}-checkbox`} />
        ) : (
          <Radio value={value} className='sr-only' />
        )}

        <Card.Meta
          title={
            content?.title ? (
              <Typography.Title level={5} className='mb-0'>
                {content.title}
              </Typography.Title>
            ) : undefined
          }
          description={
            <span className={content?.title ? 'text-content-body' : 'text-content-title'}>{content.description}</span>
          }
        />
      </Card>
    );
  });

  if (isMultiple) {
    return (
      <Checkbox.Group value={selection} className={GROUP_CLASS_NAME}>
        {items}
      </Checkbox.Group>
    );
  }

  return (
    <Radio.Group value={selection[0]} className={GROUP_CLASS_NAME}>
      {items}
    </Radio.Group>
  );
};

export default Options;
